import { Card } from '@/components/ui/card';
import { AlertCircle } from 'lucide-react';

export function ErrorState({ message }: { message?: string }) {
  return (
    <Card className="border-accent-danger">
      <div className="flex items-start gap-3">
        <AlertCircle className="h-5 w-5 text-accent-danger flex-shrink-0 mt-0.5" />
        <div>
          <p className="font-medium">Something went wrong</p>
          <p className="text-muted text-sm mt-1">{message ?? 'Reload the page to try again.'}</p>
        </div>
      </div>
    </Card>
  );
}
